import React from "react";
import { TableContainer, Paper, Table, TableBody } from "@mui/material";
import { IControl } from "../types";
import { ITimer } from "./types";
import TimerListItem from "./TimerListItem";

const TimerList = (props: { control: IControl; timers: ITimer[] }) => {
  const { control, timers } = props;
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableBody>
          {timers.map((timer, index) => (
            <TimerListItem key={index} control={control} timer={timer} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TimerList;
